import script from "./AppBasket.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBasket.vue?vue&type=script&setup=true&lang=js"

import "./AppBasket.vue?vue&type=style&index=0&id=65f19e38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f19e38"]])

export default __exports__